<template>
  <div class="u-wrap">

    <div class="qd-card">
            <div class="qd-item" v-for="(item,index) in list" :key="index">
              <div class="name">{{item.name}}</div>
              <div class="ms">{{item.ms}}</div>
            </div>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[
        {name:'身份证号、手机号',ms:'用于实名认证。'},
        {name:'行政区划',ms:'用于随手报事件，在群众未被包联时，自动上报到对应镇级。'},
        {name:'位置',ms:'用于长武蓝签到和随手报功能。'},
        {name:'图片和视频',ms:'用于随手报、民情直通车、村民圈社区圈等功能。'},
      ]
    }
  },
  created() {
  },
  computed: {},
  methods: {
   
  }
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  padding: 10px;
}

.qd-card{
  background: #FFFFFF;
  border-radius: 4px;
  padding: 0 10px;

  .qd-item{
    padding: 14px 0 12px;

    .name{
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        margin-bottom: 7px;
    }

    .ms{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }

    &:not(:last-child){
      border-bottom: 1px solid #E6E6E6;
    }
  }
}
</style>
